import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: item.href
        ? { '@id': `${window.location.origin}${__BASE_PATH__}${item.href}`, name: item.label }
        : { name: item.label },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-2 text-xs text-foreground-500 py-3">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-2">
            {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}